var exports = {
  "bL": "Root__ntkMBt",
  "y9": "FooterRedesignOffset__vKGh-z",
  "Wu": "PageLayoutRoot__Qy8-se",
  "Y9": "Header__XWjMg4",
  "Bx": "Sidebar__z_2QrT",
  "x2": "SidebarTrigger__KOX2oJ",
  "wN": "HeaderInner__O2ZDqd",
  "R4": "DialogBody__BU1di6",
  "Es": "DialogFooter__ZnoL82",
};

module.exports = exports;
